import Vue from 'vue'
import App from './App'
import router from './router'

import VueI18n from 'vue-i18n' //語言包
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap'
import ProgressBar from 'vuejs-progress-bar'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
// import { faUserSecret, faCirclePlay } from '@fortawesome/free-solid-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)
    // library.add(faUserSecret, faCirclePlay)

import global_ from './components/Global'
Vue.prototype.GLOBAL = global_
Vue.use(VueI18n) //使用插件語言
Vue.use(VueAxios, axios)
Vue.use(ProgressBar)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
    //跨域
    //axios.defaults.withCredentials = true;
    //語言設定
    var lang = localStorage.getItem('lang');   
    if(lang == null){lang = 'tw'};
var i18n = new VueI18n({
        locale: lang,
        messages: {
            'en': require('@/lang/en.json'),
            'tw': require('@/lang/tw.json')
        }
    })
    /* eslint-disable no-new */
export const app = new Vue({
    el: '#app',
    router,
    i18n, //語言包
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js